import React from 'react'
import Table from '../../widgets/Table'
import { selectUnengagedUsers } from './reports.selectors'
import { useSelector } from 'react-redux'
import SortingCustomIcon from '../../widgets/SortingCustomIcon'
import { GetUserThumbnail } from '../helpers/GetUserThumbnail'
import { REGIONS } from '../../widgets/busyIndicator'
import { getDateAndTimeFormatter } from '../../widgets/CustomDateRangePicker/CustomDateRangePicker.utils'
import {
	getFormattedTitle,
	getFormattedAccountName,
} from '../Reports/reports.constants'
import DashboardCard from '../../components/cards/DashboardCard'

const UnengagedUsers = () => {
	const unengagedUsers = useSelector(selectUnengagedUsers)

	const thumbnailFormatter = (name, row) => GetUserThumbnail(row)

	const columns = [
		{
			dataField: 'userName',
			text: 'Name',
			sort: true,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'accountName',
			text: 'Account',
			title: getFormattedTitle,
			formatter: getFormattedAccountName,
			sort: true,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'lastLogin',
			text: 'Last Login',
			sort: true,
			sortCaret: SortingCustomIcon,
			formatter: getDateAndTimeFormatter,
		},
	]

	return (
		<DashboardCard title='Unengaged Users'>

				<Table
					keyField='userId'
					columns={columns}
					data={unengagedUsers}
					region={REGIONS.FETCH_UNENGAGED_USERS}
					isDisplayTable={true}
					scrollContainerClassName='max-h-[300px] overflow-auto'
				/>
		</DashboardCard>
	)
}

export default UnengagedUsers
